
export default function Reservation() {
  const whatsappBrunchMessage = encodeURIComponent(
    "Bonjour 😊\n\n" +
    "Je souhaite réserver pour le brunch.\n\n" +
    "📩 Informations de réservation :\n" +
    "• Jour souhaité (Lundi / Samedi / Dimanche) : \n" +
    "• Service (si Sam/Dim : Service 1 (10h-12h) ou Service 2 (13h-15h)) : \n" +
    "• Nombre de personnes : \n" +
    "• Prénom : \n\n" +
    "Merci !"
  );

  const whatsappBarMessage = encodeURIComponent(
    "Bonjour 😊\n\n" +
    "Je souhaite réserver pour le bar à tapas.\n\n" +
    "📩 Informations de réservation :\n" +
    "• Jour souhaité (Jeudi / Vendredi / Samedi / Dimanche / Lundi) : \n" +
    "• Heure souhaitée : \n" +
    "• Nombre de personnes : \n" +
    "• Prénom : \n\n" +
    "Merci !"
  );

  return (
    <section id="reservation" className="py-16 md:py-20 px-4 md:px-6 bg-[#F5E6D3] relative overflow-hidden">
      <div className="max-w-5xl mx-auto relative z-10">
        {/* Title */}
        <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-[#4A7C59] text-center mb-3 md:mb-4 px-4" style={{ fontFamily: 'Pacifico, cursive' }}>
          On vous attend ! 🌴
        </h2>
        <p className="text-center text-gray-600 mb-8 md:mb-12 text-base md:text-lg px-4">
          Réservez votre table pour une expérience tropicale inoubliable
        </p>

        {/* Reservation Type Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 mb-10 md:mb-12">
          {/* Brunch Reservation */}
          <div className="bg-white rounded-3xl p-6 md:p-8 shadow-xl">
            <div className="text-center mb-6">
              <div className="w-20 h-20 mx-auto mb-4 bg-gradient-to-br from-[#FF8F6B] to-[#ff6b47] rounded-full flex items-center justify-center">
                <i className="ri-restaurant-line text-4xl text-white"></i>
              </div>
              <h3 className="text-2xl md:text-3xl font-bold text-[#4A7C59] mb-2">Brunch</h3>
              <p className="text-gray-600 text-sm md:text-base">Pancakes, pain perdu, salades, charcuterie, fromages, plats chauds & desserts maison</p>
            </div>
            
            <div className="bg-[#F5E6D3] rounded-2xl p-4 md:p-5 mb-6">
              <h4 className="font-bold text-[#4A7C59] mb-3 text-center">🥞 Horaires Brunch</h4>
              <div className="space-y-2 text-sm md:text-base">
                <div className="flex justify-between">
                  <span className="font-semibold">Lundi</span>
                  <span>11h-14h</span>
                </div>
                <div className="flex justify-between">
                  <span className="font-semibold">Samedi & Dimanche</span>
                  <span>10h-12h / 13h-15h</span>
                </div>
              </div>
            </div>

            <a
              href={`https://wa.me/262693527676?text=${whatsappBrunchMessage}`}
              target="_blank"
              rel="noopener noreferrer"
              className="w-full flex items-center justify-center gap-3 bg-[#25D366] text-white px-6 py-4 rounded-full text-lg font-semibold hover:bg-[#20BA5A] transition-all transform hover:scale-105 shadow-lg cursor-pointer whitespace-nowrap"
            >
              <i className="ri-whatsapp-line text-2xl"></i>
              Réserver le Brunch
            </a>
          </div>

          {/* Bar & Tapas Reservation */}
          <div className="bg-white rounded-3xl p-6 md:p-8 shadow-xl border-4 border-[#4A7C59]">
            <div className="text-center mb-6">
              <div className="w-20 h-20 mx-auto mb-4 bg-gradient-to-br from-[#4A7C59] to-[#3d6849] rounded-full flex items-center justify-center">
                <i className="ri-goblet-line text-4xl text-white"></i>
              </div>
              <h3 className="text-2xl md:text-3xl font-bold text-[#4A7C59] mb-2">Bar & Tapas 🍹</h3>
              <p className="text-gray-600 text-sm md:text-base font-semibold">Planches charcuterie, fromages, tapenades & cocktails</p>
              <p className="text-[#FF8F6B] text-xs md:text-sm font-bold mt-2">✨ Licence 4 - Bar complet avec spiritueux</p>
            </div>
            
            <div className="bg-[#4A7C59] text-white rounded-2xl p-4 md:p-5 mb-6">
              <h4 className="font-bold mb-3 text-center">🍹 Horaires Bar & Tapas</h4>
              <div className="space-y-2 text-sm md:text-base">
                <div className="flex justify-between">
                  <span className="font-semibold">Jeudi, Dimanche, Lundi</span>
                  <span>17h30-22h</span>
                </div>
                <div className="flex justify-between">
                  <span className="font-semibold">Vendredi & Samedi</span>
                  <span>17h30-23h</span>
                </div>
              </div>
            </div>

            <a
              href={`https://wa.me/262693527676?text=${whatsappBarMessage}`}
              target="_blank"
              rel="noopener noreferrer"
              className="w-full flex items-center justify-center gap-3 bg-[#4A7C59] text-white px-6 py-4 rounded-full text-lg font-semibold hover:bg-[#3d6849] transition-all transform hover:scale-105 shadow-lg cursor-pointer whitespace-nowrap"
            >
              <i className="ri-whatsapp-line text-2xl"></i>
              Réserver Bar & Tapas
            </a>
          </div>
        </div>

        {/* Contact Methods */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6 mb-8">
          {/* Phone */}
          <a
            href="tel:+262693527676"
            className="bg-white rounded-2xl p-5 shadow-lg hover:shadow-xl transition-all transform hover:scale-105 cursor-pointer group text-center"
          >
            <div className="w-14 h-14 flex items-center justify-center bg-gradient-to-br from-[#FF8F6B] to-[#ff6b47] rounded-full mx-auto mb-3 group-hover:scale-110 transition-all">
              <i className="ri-phone-line text-2xl text-white"></i>
            </div>
            <h4 className="font-bold text-[#4A7C59] mb-1">Téléphone</h4>
            <p className="text-[#FF8F6B] font-semibold text-sm">+262 693 52 76 76</p>
          </a>

          {/* Email */}
          <a
            href="mailto:lebokalgivre.cie@gmail.com"
            className="bg-white rounded-2xl p-5 shadow-lg hover:shadow-xl transition-all transform hover:scale-105 cursor-pointer group text-center"
          >
            <div className="w-14 h-14 flex items-center justify-center bg-gradient-to-br from-[#4A7C59] to-[#3d6849] rounded-full mx-auto mb-3 group-hover:scale-110 transition-all">
              <i className="ri-mail-line text-2xl text-white"></i>
            </div>
            <h4 className="font-bold text-[#4A7C59] mb-1">Email</h4>
            <p className="text-[#4A7C59] font-semibold text-xs break-words">lebokalgivre.cie@gmail.com</p>
          </a>

          {/* Instagram */}
          <a
            href="https://www.instagram.com/lebokalgivre/"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-white rounded-2xl p-5 shadow-lg hover:shadow-xl transition-all transform hover:scale-105 cursor-pointer group text-center"
          >
            <div className="w-14 h-14 flex items-center justify-center bg-gradient-to-br from-[#E1306C] to-[#C13584] rounded-full mx-auto mb-3 group-hover:scale-110 transition-all">
              <i className="ri-instagram-line text-2xl text-white"></i>
            </div>
            <h4 className="font-bold text-[#4A7C59] mb-1">Instagram</h4>
            <p className="text-[#E1306C] font-semibold text-sm">@lebokalgivre</p>
          </a>
        </div>

        {/* Call to Action */}
        <div className="text-center bg-white rounded-2xl p-6 shadow-lg">
          <p className="text-gray-600 text-base md:text-lg mb-2">
            💡 <strong>Astuce :</strong> Réservez à l'avance pour garantir votre place !
          </p>
          <p className="text-sm text-gray-500">
            Nous sommes ouverts en soirée du jeudi au lundi pour le bar à tapas 🍹
          </p>
        </div>
      </div>
    </section>
  );
}